import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { imgref } from './imgref'
 import './Photos.css'


const Photos = () => {
  const autoplayOptions = {
    delay: 1800,
    stopOnInteraction:false
  }
  const [emblaCert] = useEmblaCarousel({ loop: true },[Autoplay(autoplayOptions)])
  return (
    <>
    <div  className='certs_parent'>
      <h1 className='certs-header' style={{color:"red"}}>Gallery</h1>
      <hr className='certs-divider'></hr>
    <div className="certs " ref={emblaCert}>
      <div className="certs__container">
        
          {
            imgref.map((item,index) => {
              return(
                <div   key={index} className="certs__slide">
                  
                  <div className="certs_contents">
                    <div>
                   
                        <img  className="certs_slider_images" src={item.url}></img>
                  
                      </div>
                  </div>
                
                </div>
              )
            })
          }
        
      </div>
    </div>
    </div>
    <div className='qc'>
  
      <h2>FOR FURTHER QUERIES PLEASE CONTACT:</h2>
      
      <ul>
        <li>Ms.T.Mangayarkarasi - 87545 02226</li>
        <li>Dr.V.Brindha Devi - 87545 82225</li>
        <li>Dr.K.Renganathan - 87545 02228</li>
        <li>Dr.G.Prakash - 87545 82221</li>
        <li>Mr.R.Sambasivam - 87545 57999</li>
        <li>Mr.C.Srinivasan - 87545 56444</li>
      </ul>

    </div>
    </>
  )

}
export default Photos
